// TODO incomplete
const riskAssessmentRoads = {
	gid: {
		name: 'Road id',
	},
	fclass: {
		name: 'Road type',
		description: 'Road type from Open Street Map',
	},
	rd_len: {
		name: 'Length of segment',
		unit: 'm',
	},
	cm_haz: {
		name: 'Nearby zonal annual subsidence rate',
		unit: 'mm/yr',
	},
};

const riskAssessmentZones = {
	chng_type: {
		name: 'Built-up change',
	},
	chng_year: {
		name: 'Year of built-up extension',
	},
	chng_year_: {
		name: 'Year of built-up extension',
	},
	defo_max: {
		name: 'Maximum',
		unit: 'mm/yr',
	},
	defo_median: {
		name: '50-percentile (median)',
		unit: 'mm/yr',
	},
	defo_mean: {
		name: 'Mean',
		unit: 'mm/yr',
	},
	defo_min: {
		name: 'Minimum',
		unit: 'mm/yr',
	},
	defo_p25: {
		name: '25-percentile',
		unit: 'mm/yr',
	},
	defo_p75: {
		name: '75-percentile',
		unit: 'mm/yr',
	},
	defo_std: {
		name: 'Standard deviation',
		unit: 'mm/yr',
	},
	haz_0_10: {
		name: 'Displacement rates 0 – 10 mm/yr',
		description:
			'Number of measurement points with absolute annual displacement rate between 0 – 10 mm / year within the block',
	},
	haz_10_20: {
		name: 'Displacement rates 10 - 20 mm/yr',
		description:
			'Number of measurement points with absolute annual displacement rate between 10 - 20 mm / year within the block',
	},
	haz_20_30: {
		name: 'Displacement rates 20 - 30 mm/yr',
		description:
			'Number of measurement points with absolute annual displacement rate between 20 - 30 mm / year within the block',
	},
	haz_30_40: {
		name: 'Displacement rates 30 - 40 mm/yr',
		description:
			'Number of measurement points with absolute annual displacement rate between 30 - 40 mm / year within the block',
	},
	haz_40_50: {
		name: 'Displacement rates 40 - 50 mm/yr',
		description:
			'Number of measurement points with absolute annual displacement rate between 40 - 50 mm / year within the block',
	},
	haz_50__: {
		name: 'Displacement rates > 50 mm/yr',
		description:
			'Number of measurement points with absolute annual displacement rate between > 50 / year within the block',
	},
	lmi_hh: {
		name: 'Share of clustered uplifting points',
	},
	lmi_hl: {
		name: 'Share of uplifting outliers',
	},
	lmi_lh: {
		name: 'Share of subsiding outliers',
	},
	lmi_ll: {
		name: 'Share of clustered subsiding points',
	},
	mp_cnt: {
		name: 'Number of measurement points within the block',
	},
	rel_a: {
		name: 'Class A',
		description:
			'Number of A-class measurement points within the block (A-most reliable, E-least reliable)',
	},
	rel_b: {
		name: 'Class B',
		description:
			'Number of B-class measurement points within the block (A-most reliable, E-least reliable)',
	},
	rel_c: {
		name: 'Class C',
		description:
			'Number of C-class measurement points within the block (A-most reliable, E-least reliable)',
	},
	rel_d: {
		name: 'Class D',
		description:
			'Number of D-class measurement points within the block (A-most reliable, E-least reliable)',
	},
	rel_e: {
		name: 'Class E',
		description:
			'Number of E-class measurement points within the block (A-most reliable, E-least reliable)',
	},
	ua_l3: {
		name: 'Land use class code',
	},
	zone_id: {
		name: 'Land use block ID',
	},
};

const interferometry = {
	az_ang: {
		name: 'Radar azimuth angle (LOS)',
		unit: '°',
		description: 'Azimuth angle of the LOS',
	},
	cl_ue: {
		name: 'Unwrapping error risk level',
		description:
			'Estimated probability, that there is an unwrapping error in the time series. As there are more possible unwrapping errors in the time series, this number is cumulative. If an unwrapping error is corrected (with probability over 50 %), this probability goes negative (1 – original risk)',
	},
	cl_warn: {
		name: 'Alarms',
		description:
			'Warnings based on presence of hazard markers. Hazard markers are related to specific patterns detected in measurements from the last year. (10 - Displacement acceleration / 20 - Displacement decceleration / 11 - Rapid decrease of interferometric reliability (~increase in noise level)/ 12,22 -Abrupt jump in displacement trend / 500 - Abrupt inversion of displacement trend)',
	},
	cm_coh: {
		name: 'Interferometric reliability',
		description:
			'Reliability class based on coherence values. A - best reliability, E-worst reliability',
	},
	coh: {
		name: 'Interferometric coherence',
		description:
			'Temporal coherence - measure of interferometric quality ranging from 0 to 1 (0-worst, 1-best quality). It is a function (cross-correlation) of phase stability of each target - measurement point - and denotes a fit of detected displacement trend to selected model (mostly linear).',
	},
	corr_ue: {
		name: 'Number of corrected unwrapping errors',
		description:
			'Number of unwrapping errors in the time series, which were found and corrected',
	},
	h: {
		name: 'Height from the reference DEM',
		unit: 'm',
		description: 'Height of the point taken from the reference DEM',
	},
	h_ref: {
		name: 'Relative height (above reference DEM)',
		unit: 'm',
		description: 'Estimated relative height of the point (above reference DEM)',
	},
	h_sd: {
		name: 'Standard deviation of the relative height',
		unit: 'm',
		description: 'Standard deviation of the estimated relative height',
	},
	id: {
		name: 'Persistent scatterer point ID',
		description: 'Unique ID of PS/DS point',
	},
	inc_ang: {
		name: 'Radar incidence angle (LOS)',
		unit: '°',
		description:
			'Local incidence angle of the LOS. Related to positin within satellite scene from specific orbital track.',
	},
	lmi_idx: {
		name: "Local Moran's I index",
		description:
			'A positive value of the statistic I indicates that surrounding measurement points have similar high or low annual displacement rates; this point is part of a cluster. A negative value for I indicates that a measurement point is surrounded by points with dissimilar values; this point is an outlier. In either instance, the p-value for the feature must be small enough for the cluster or outlier to be considered statistically significant. For more details refer to: https://desktop.arcgis.com/en/arcmap/10.3/tools/spatial-statistics-toolbox/h-how-cluster-and-outlier-analysis-anselin-local-m.htm',
	},
	lmi_potype: {
		name: 'Type of spatial pattern: cluster / outlier',
		description:
			'Typology of statistically significant clusters and outliers of annual displacement rates at a 95 percent confidence level. (HH - Cluster of uplifting points / HL - Outlier uplifting  point / LH - Outlier subsiding point / LL - Cluster of subsiding points)',
	},
	lmi_pval: {
		name: 'p-value',
		description:
			'Measure of statistical significance indicating probability that spatial pattern is result of random process. Proxy to confidence level related to rejection of null hypothesis about that pattern of surrounding annual displacement rates is completely random. For more details refer to: https://desktop.arcgis.com/en/arcmap/10.3/tools/spatial-statistics-toolbox/what-is-a-z-score-what-is-a-p-value.htm',
	},
	lmi_zscore: {
		name: 'z-score',
		description:
			'Critical value (based on standard deviation) indicating whether the spatial pattern - similarity (a spatial clustering of either high or low values) or dissimilarity (a spatial outlier) - is more pronounced than one expected in a random distribution. A high positive z-score for a feature indicates that the surrounding measurement points have similar (either positive, or negative) annual displacement rates. A low negative z-score (for example, less than -3.96) for a measurement point indicates a statistically significant spatial data outlier. For more details refer to: https://desktop.arcgis.com/en/arcmap/10.3/tools/spatial-statistics-toolbox/what-is-a-z-score-what-is-a-p-value.htm',
	},
	method: {
		name: 'Interferometric method',
		description: 'Interferometric method used to detect measurement points',
	},
	orbit: {
		name: 'Orbital trajectory',
		description:
			'Type of orbital trajectory (Ascending / Descending) determining azimuth of LOS',
	},
	rel_track: {
		name: 'Orbital track',
		description: 'Relative no. of the orbital track',
	},
	s0: {
		name: 'Standard deviation of one (displacement) measurement',
		unit: 'mm',
		description: 'Standard deviation of one (displacement) measurement',
	},
	t_start: {
		name: 'Point detected from (date)',
		description:
			'Date since temporal reflector (measurement point) has started to be detected (based on reflectivity - relevant for persistent scatterers)',
	},
	t_stop: {
		name: 'Point detected until (date)',
		description:
			'Date when temporal reflector (measurement point) ceased to reflect any longer (based on reflectivity - relevant for persistent scatterers)',
	},
	vel_avg: {
		name: 'Annual displacement rate',
		unit: 'mm/yr',
		description:
			'Estimated annual displacement rate (average velocity) detected in direction of  satellite’s line-of-sight [mm/yr]',
	},
	vel_cum: {
		name: 'Cumulative displacement ',
		unit: 'mm',
		description:
			'Estimated cumulative displacement between the first and last acquisition [mm]',
	},
	y_start: {
		name: 'Point detected from (year)',
		description:
			'Year when temporal reflector started to be detected (based on reflectivity - relevant for persistent scatterers)',
	},
	y_stop: {
		name: 'Point detected until (year)',
		description:
			'Year when  temporal reflector  ceased to be detected any longer (based on reflectivity - relevant for persistent scatterers)',
	},

	// aspect: {
	//     "name": "Slope aspect (from DEM)",
	//     "unit": "",
	//     "description": "Slope aspect calculated from 30m Copernicus DEM"
	// },
	// cl_dyn: {
	//     "name": "Displacement trend dynamics",
	//     "unit": "",
	//     "description": "Dynamics of displacement trend over the whole period of observation"
	// },
	// cl_prg: {
	//     "name": "Displacement trend",
	//     "unit": "",
	//     "description": "Displacement trend over the whole period of observation "
	// },
	// rel_cm: {
	//     "name": "PSI reliability class",
	//     "description": "Reliability class based on combination of coherence and sensitivy. A - best reliability, D-worse reliability"
	// },
	// sens: {
	//     "name": "Radar sensitivity",
	//     "unit": "",
	//     "description": "Sensitivity of radar geometry (LOS) to down-the-slope (DTS) direction"
	// },
	// slope: {
	//     "name": "Slope gradient (from DEM)",
	//     "unit": "",
	//     "description": "Slope grading calculated from 30m Copernicus DEM"
	// },
	// vacc_mod: {
	//     "name": "Model displacement rate accuracy",
	//     "unit": "mm/yr",
	//     "description": ""
	// },
	// vel_acc: {
	//     "name": "Standard deviation of annual displacement rate",
	//     "unit": "mm/yr",
	//     "description": "Standard deviation of annual displacement rate"
	// },
	// val_rank: {
	//     "name": "Validation score",
	//     "description": "Number of successfully passed statistical tests in frame of internal validation using measurements from individual"
	// },
	// vel_sd: {
	//     "name": "Standard deviation of annual displacement rate",
	//     "unit": "mm/yr",
	//     "description": "Standard deviation of annual displacement rate"
	// },
	// xxx: {
	//     "name": "",
	//     "unit": "",
	//     "description": ""
	// },
};

export default {
	interferometry,
	riskAssessment: {
		zones: riskAssessmentZones,
		roads: riskAssessmentRoads,
	},
};
